<template>
    <div id="page">
        <div class="flex_b pad14 alc" id="toolH">
            <div>
                <el-select class="marr4" v-model="i_gsid" size="mini"   filterable clearable>
                    <el-option v-for="item in comList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-select   class="marr4" v-model="i_ckid" size="mini"   filterable >
                    <el-option v-for="item in ckList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-select class="marr4" style="width: 80px" v-model="i_xtype" size="mini"  >
                    <el-option v-for="item in typeList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <el-input style="width: 220px;margin-left: 10px" class="marr4" size="mini" :placeholder="$t('moveInventory_product_search')" clearable v-model="vc_search">
                </el-input>
                <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            </div>
            <div>
                <el-date-picker style="width: 220px" class="marr4" size="mini" v-model="valuetime" @change="getTimes"
                        :clearable="false" type="daterange" :range-separator="$t('form_to')" :start-placeholder="$t('form_start_date')" :end-placeholder="$t('form_end_date')">
                </el-date-picker>
                <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="switchrequestlist">{{$t('moveInventory_inventory_transfer_history')}}</el-button>

            </div>
        </div>
        <el-table v-loading="loading" ref="table" size="mini" border :data="tableData" :height="tableHeight"
            :header-cell-style="{background:'#eef1f6',color:'#000'}" :row-class-name="rowClassName">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column type="index" :label="$t('form_serial_number')" width="50"></el-table-column>
<!--            <el-table-column prop="i_id" label="ID" show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="vc_pzname" :label="$t('moveInventory_product_name')" show-overflow-tooltip></el-table-column>
            <el-table-column prop="vc_ckname" :label="$t('form_warehouse')"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="vc_gsname" :label="$t('form_company')"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="vc_no" :label="$t('moveInventory_batch_no')"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="i_wzid" :label="$t('moveInventory_warehouse_location')"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="i_scid" :label="$t('moveInventory_production_id')"  show-overflow-tooltip></el-table-column>
            <el-table-column prop="f_kcsl" :label="$t('moveInventory_warehouse_stock_quantity')"  show-overflow-tooltip>
                <template slot-scope="scope"><div class="numstyle">{{scope.row.f_kcsl}}</div></template>

            </el-table-column>
            <el-table-column prop="f_kysl" :label="$t('moveInventory_business_available_quantity')"  show-overflow-tooltip>
                <template slot-scope="scope"><div  class="numstyle">{{scope.row.f_kysl}}</div></template>

            </el-table-column>
            <el-table-column prop="vc_bzstyle" :label="$t('moveInventory_specification')" ></el-table-column>
            <el-table-column prop="vc_unit" :label="$t('moveInventory_unit')" width="60"></el-table-column>
            <el-table-column prop="vc_no_hs" :label="$t('moveInventory_cost_accounting_batch')" ></el-table-column>
<!--            <el-table-column  label="录入人" prop="vc_lruname"  show-overflow-tooltip></el-table-column>-->
<!--            <el-table-column label="录入时间" prop="dt_createtime"  show-overflow-tooltip></el-table-column>-->
            <el-table-column prop="i_xtype" :label="$t('moveInventory_type')" width="50">
                <template slot-scope="scope">{{scope.row.i_xtype==1?$t('moveInventory_export_sale'):$t('moveInventory_domestic_sale')}}</template>
            </el-table-column>
            <el-table-column width="60" :label="$t('form_operate')">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="goEdit(scope.row)">{{scope.row.i_xtype==1?$t('moveInventory_switch_to_domestic_sale'):$t('moveInventory_switch_to_export_sale')}}</el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination class="fr mrr9 padT6" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page.sync="currentPage" :page-sizes="[20, 30, 50]" :page-size="pageSize"
                layout="sizes, prev, pager, next" :total="tableTotal">
        </el-pagination>
        <div :class="baseerp+'div'" class="cgdia">
            <el-dialog width="800px" :title="title" :visible.sync="dialogVisible"
                    :close-on-click-modal="false" @close="cancelDialog" v-if="dialogVisible">
                <add-page :data="addData" @close="cancelDialog"></add-page>
            </el-dialog>
        </div>
        <div class="contentLeft">
            <reportdialog  ref="mydialog"></reportdialog>
            <eDialog ref="eDialog" :activePage="activePage"></eDialog>
        </div>
    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import addPage from "./addPage";
    import reportdialog from "@/components/dialog"; // dialog
    import eDialog from "@/components/eDialog"; // dialog
    export default {
        components: {
            addPage,eDialog,reportdialog
        },
        data() {
            return {
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                activePage:"report/res/spread.vue",
                i_gsid:null,
                i_ckid:0,
                ckList:[],
                comList:[],
                row:{},
                vc_search:"",
                addData:{},
                title:'',
                dialogVisible:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                baseerp:"",
                mid:0,
                tableData:[],
                loading:false,
                tableHeight:0,
                typeList:[{i_id:0,vc_name:this.$t('moveInventory_domestic_sale')},{i_id:1,vc_name:this.$t('moveInventory_export_sale')}],
                i_xtype:0,
                dt_startdate: '',
                dt_enddate: '',
                valuetime:[]
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            this.getWarehouseList();
            this.getCompanyList();
            this.getfMou();
            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`
            },
            cancelDialog_dg(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getlist();
                }
                this.dialogVisible_dg=false;
            },
            gosearch(){
                if(!this.i_gsid){
                    this.$message.warning(this.$t('moveInventory_please_select_query_company'))
                }else{
                    this.currentPage=1;
                    this.tableData=[];
                    this.getlist();
                }

            },
            cancelDialog(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getlist();
                }
                this.dialogVisible=false;
                this.addData=null;
            },
            goEdit(row){
                this.title=this.i_xtype==1?this.$t('moveInventory_switch_to_domestic_sale'):this.$t('moveInventory_switch_to_export_sale');
                this.addData=row;
                delete this.addData.f_num;
                delete this.addData.i_gid;
                this.dialogVisible=true;
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getlist()
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getlist()
            },
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },

            async switchrequestlist() {
                let i_gsid=this.i_gsid;
                // this.formonth=data.forMonth
                if(!this.i_gsid){
                    i_gsid=0
                    // this.$message.warning('请选择查询公司')
                    // return
                }
                let loading =this.$loading({lock:true,text:this.$t('tips_loading_data_please_wait'),background:"rgba(0,0,0,0.5)"});
                // this.$refs.eDialog.showDialog({title:"报表",btn:{f:this.btn,l:{a:{title:"a",name:"a1"}}},parm:{type:'AttMonthRpt',mid:this.$route.meta.mid},w:800,h:600});
                this.$refs.eDialog.showDialog({
                    title:this.$t('moveInventory_inventory_transfer_history'),
                    parm:{
                        type:'InventorySwitchRecord',
                        mid:this.$route.meta.mid,
                        arg:{
                            i_gsid:i_gsid,
                            i_ckid:this.i_ckid,
                            sDate:this.dt_startdate,
                            eDate:this.dt_enddate,
                            vc_search:this.vc_search,
                        }},
                    w:1024,h:768});
                loading.close();
                document.addEventListener('click',function(e){
                    loading.close()
                })

            },
            //公司列表
            async getCompanyList(){
                let param={
                    i_type:"0,2"
                };
                let res=await API.getCompanyList(param);
                if(res.code==1){
                    this.comList=res.data;
                    // this.comList.unshift({i_id:0,vc_name:'全部'});
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //仓库列表
            async getWarehouseList(){
                let param={
                };
                //console.log(param,'param');
                let res=await API.getWarehouseList(param);
                if(res.code==1){
                    this.ckList=res.data;
                    this.ckList.unshift({i_id:0,vc_name:this.$t('state_all')});
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getlist(){
                this.tableData=[]
                this.dataText=this.$t('tips_data_loading_in_progress');
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                    i_ckid:this.i_ckid,
                    i_pzid:this.i_pzid,
                    i_gsid:this.i_gsid,
                    i_xtype:this.i_xtype,
                };
                //console.log(param,'param');
                let res=await API.getlist(param);
                if ( res.code == 1 ){
                    /*res.data.list.map(item=>{
                        item.edit=true;
                    })*/
                    if (res.data.list.length==0) {this.dataText=this.$t('tips_no_data_available_at_the_moment')};
                    this.tableData=res.data.list;
                    this.tableTotal=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                // this.getlist();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                // this.currentPage=1;
                // this.tableData=[];
                // this.getlist();
            },
        },
    }
</script>

<style  lang="scss" scoped>

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
    .numstyle{
        text-align: right;
        font-weight: bold;
    }
</style>